import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Tooltip,
} from '@chakra-ui/react'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import React from 'react'
import type { ReactElement } from 'react'
import DatePicker from 'react-datepicker'
import { isNull, isUndefined } from 'lodash'
import type { CmFormValues } from '../../../../interfaces/FileDetailsResponse'
import DateCustomInput from '../../../DateCustomInput'
import type { CMFieldProps } from '.'
import 'react-datepicker/dist/react-datepicker.css'
import EllipsisMiddle from '../../../EllipsisMiddle'

const CMDateField = ({
  cmField,
  disabled,
  isUpload,
}: CMFieldProps): ReactElement => (
  <Field  name={`['${cmField.name}']`} key={`['${cmField.name}']`}>
    {({ field, form }: FieldProps<string, CmFormValues>) => (
      <FormControl
        marginBottom={isUpload ? 0 : '30px'}
        isInvalid={Boolean(form.errors[cmField.name])}
        isRequired={cmField.schema.isValueRequired}
        isDisabled={disabled}
      >
        <Tooltip label={cmField.label} placement="top-start">
          <FormLabel requiredIndicator={<></>}>
            <Flex maxWidth="20vw">
              <EllipsisMiddle text={cmField.label} required={cmField.schema.isValueRequired} className="centerText" />
            </Flex>
          </FormLabel>
        </Tooltip>
        <DatePicker
          placeholderText={(!(isUndefined(cmField?.schema?.defaultValue) ||
            isNull(cmField.schema.defaultValue)) && isUpload
            ? `${new Date(cmField.schema.defaultValue.toString()).toLocaleDateString()} (Default value)` : "")}
          disabled={disabled}
          readOnly={disabled}
          selected={field.value ? new Date(field.value) : undefined}
          isClearable={!disabled}
          customInput={React.createElement(React.forwardRef(DateCustomInput))}
          onChange={(newDate: Date | null) => {
            if (isNull(newDate)) {
              form.setFieldValue(field.name, null)
            } else {
              form.setFieldValue(field.name, newDate.toISOString())
            }
          }}
        />
        <FormErrorMessage>{form.errors[cmField.name]}</FormErrorMessage>
      </FormControl>
    )}
  </Field>
)

export default CMDateField
